interface GetDateForTimeOptions {
  hours: number;
}

function getDateForTime(options: GetDateForTimeOptions): Date {
  const now = new Date();

  return new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    options.hours
  );
}

export default getDateForTime;
